<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-card>
          <v-card-title class="mx-3  px-0 mb-3" style="border-bottom:2px solid #D7531F">
            <v-col cols="12" md="6">

            <v-icon style="margin-right: 20px; color: #00294b" size="50">
              mdi-lock
            </v-icon>
            Segurança
            </v-col>
          </v-card-title>
          <v-card-text>
            <h3
              style="
                font-family: poppins !important;
                font-weight: 600;
                color: #686868 !important;
              "
            >
              Autenticação de Dois Fatores (2FA)
            </h3>
            <v-row justify="center" align="center" class="heigthMobile">
              <v-col
                cols="12"
                md="10"
                class="d-flex align-center"
              >
                {{ user.users_auth === null ? "Desativado" : "Ativado" }}
                {{ user.users_auth !== null ? user.users_auth : ""}}
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center">
                <v-btn
                  small
                  class=""
                  outlined
                  color="green"
                  @click="change2FA"
                v-if="user.users_auth === null"
                >
                  <v-icon>mdi-check</v-icon> Ativar
                </v-btn>
                     <v-btn
                  small
                  class=""
                  outlined
                  color="orange"
                  @click="change2FA"
                v-if="user.users_auth !== null"
                >
                  <v-icon>mdi-pencil</v-icon> Alterar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
  },
  data: () => ({
    urlIndicacao: "",
  }),
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    change2FA() { 
      
    }
  },
  mounted() {},
};
</script>
